
export const MsA = [
    { name : "AK - Anchorage" },
    { name : "AL - Anniston" },
    { name : "AL - Auburn-Opelika" },
    { name : "AL - Birmingham" },
    { name : "AL - Columbus, GA-AL" }, 
    { name : "AL - Decatur" }, 
    { name : "AL - Dothan" }, 
    { name : "AL - Florence" }, 
    { name : "AL - Gadsden" }, 
    { name : "AL - Huntsville" }, 
     { name : "AL - Mobile" }, 
    { name : "AL - Montgomery" }, 
    { name : "AL - Tuscaloosa" }, 
    { name : "AR - Fayetteville-Springdale-Rogers" }, 
    { name : "AR - Fort Smith, AR-OK" }, 
    { name : "AR - Jonesboro" }, 
    { name : "AR - Little Rock-North Little Rock" }, 
    { name : "AR - Memphis,TN-AR-MS" }, 
    { name : "AR - Pine Bluff" }, 
    { name : "AR - Texarkana, TX-Texarkana, AR" }, 
     { name : "AZ - Flagstaff, AZ-UT" }, 
    { name : "AZ - Las Vegas, NV-AZ" }, 
    { name : "AZ - Phoenix-Mesa" }, 
    { name : "AZ - Tucson" }, 
    { name : "AZ - Yuma" }, 
    { name : "CA - Bakersfield" }, 
    { name : "CA - Chico-Paradise" }, 
    { name : "CA - Fresno" }, 
    { name : "CA - Los Angeles-Long Beach" }, 
    { name : "CA - Merced" }, 
     { name : "CA - Modesto" }, 
    { name : "CA - Oakland" }, 
    { name : "CA - Orange County" }, 
    { name : "CA - Redding" }, 
    { name : "CA - Riverside-San Bernardino-Ontario" }, 
    { name : "CA - Sacramento" }, 
    { name : "CA - Salinas" }, 
    { name : "CA - San Diego" }, 
    { name : "CA - San Francisco-Oakland" }, 
    { name : "CA - San Jose" }, 
     { name : "CA - San LuisObispo-Atascadero-Paso Robles" }, 
    { name : "CA - Santa Barbara-Santa Maria-Lompoc" }, 
    { name : "CA - Santa Cruz" }, 
    { name : "CA - Santa Rosa" }, 
    { name : "CA - Stockton-Lodi" }, 
    { name : "CA - Vallejo-Fairfield-Napa" }, 
    { name : "CA - Ventura" }, 
    { name : "CA - Visalia-Tulare-Porterville" }, 
    { name : "CA - Yolo" }, 
    { name : "CA - Yuba City" }, 
     { name : "CO - Boulder-Longmont" }, 
    { name : "CO - ColoradoSprings" }, 
    { name : "CO - Denver-Boulder" }, 
    { name : "CO - Fort Collins-Loveland" }, 
    { name : "CO - Grand Junction" }, 
    { name : "CO - Greeley" }, 
    { name : "CO - Pueblo" }, 
    { name : "CT - Bridgeport-Milford" }, 
    { name : "CT - Danbury" }, 
    { name : "CT - Hartford" }, 
     { name : "CT - New Haven-Meriden" }, 
    { name : "CT - New London-Norwich, CT-RI" }, 
    { name : "CT - Stamford" }, 
    { name : "CT - Waterbury" }, 
    { name : "CT - Worcester, MA" }, 
    { name : "DC - Washington, DC-MD-VA" }, 
    { name : "DE - Dover" }, 
    { name : "DE - Wilmington, DE-NJ-MD" }, 
    { name : "FL - DaytonaBeach" }, 
    { name : "FL - Fort Lauderdale-Hollywood" }, 
     { name : "FL - Fort Myers-Cape Coral" }, 
    { name : "FL - Fort Pierce-Port St. Lucie" }, 
    { name : "FL - Fort Walton Beach" }, 
    { name : "FL - Gainesville" }, 
    { name : "FL - Jacksonville" }, 
    { name : "FL - Lakeland-Winter Haven" }, 
    { name : "FL - Melbourne-Titusville-Palm Bay" }, 
    { name : "FL - Miami" }, 
    { name : "FL - Naples" }, 
    { name : "FL - Ocala" }, 
     { name : "FL - Orlando" }, 
    { name : "FL - Panama City" }, 
    { name : "FL - Pensacola" }, 
    { name : "FL - Punta Gorda" }, 
    { name : "FL - Sarasota-Bradenton" }, 
    { name : "FL - Tallahassee" }, 
    { name : "FL - Tampa-St. Petersburg-Clearwater" }, 
    { name : "FL - West Palm Beach-Boca Raton" }, 
    { name : "GA - Albany" }, 
    { name : "GA - Athens" }, 
     { name : "GA - Atlanta" }, 
    { name : "GA - Augusta-Aiken, GA-SC" }, 
    { name : "GA - Chattanooga, TN-GA" }, 
    { name : "GA - Columbus, GA-AL" }, 
    { name : "GA - Macon" }, 
    { name : "GA - Savannah" }, 
    { name : "HI - Honolulu" }, 
    { name : "IA - Cedar Rapids" }, 
    { name : "IA - Davenport-Moline-Rock Island, IA-IL" }, 
    { name : "IA - Des Moines" }, 
      { name : "IA - Dubuque" }, 
     { name : "IA - Iowa City" }, 
     { name : "IA - Omaha, NE-IA" }, 
     { name : "IA - Sioux City, IA-NE" }, 
     { name : "IA - Waterloo-Cedar Falls" }, 
     { name : "ID - Boise City" }, 
     { name : "ID - Pocatello" }, 
     { name : "IL - Bloomington-Normal" }, 
     { name : "IL - Champaign-Urbana" }, 
     { name : "IL - Chicago" }, 
     { name : "IL - Davenport-Moline-Rock Island, IA-IL" }, 
    { name : "IL - Decatur" }, 
    { name : "IL - Kankakee" }, 
    { name : "IL - Peoria-Pekin" }, 
    { name : "IL - Rockford" }, 
    { name : "IL - Springfield" }, 
    { name : "IL - St. Louis, MO-IL" }, 
    { name : "IN - Bloomington" }, 
    { name : "IN - Cincinnati, OH-KY-IN" }, 
    { name : "IN - Elkhart-Goshen" }, 
     { name : "IN - Evansville-Henderson, IN-KY" }, 
    { name : "IN - Fort Wayne" }, 
    { name : "IN - Gary-Hammond-East Chicago" }, 
    { name : "IN - Indianapolis" }, 
    { name : "IN - Kokomo" }, 
    { name : "IN - Lafayette" }, 
    { name : "IN - Louisville, KY-IN" }, 
    { name : "IN - Muncie" }, 
    { name : "IN - South Bend" }, 
    { name : "IN - Terre Haute" }, 
     { name : "KS - Kansas City, MO-KS" }, 
    { name : "KS - Lawrence" }, 
    { name : "KS - Topeka" }, 
    { name : "KS - Wichita" }, 
    { name : "KY - Cincinnati, OH-KY-IN" }, 
    { name : "KY - Clarksville-Hopkinsville, TN-KY" }, 
    { name : "KY - Evansville-Henderson, IN-KY" }, 
    { name : "KY - Huntington-Ashland, WV-KY-OH" }, 
    { name : "KY - Lexington" }, 
    { name : "KY - Louisville, KY-IN" }, 
     { name : "KY - Owensboro" }, 
    { name : "LA - Alexandria" }, 
    { name : "LA - Baton Rouge" }, 
    { name : "LA - Houma" }, 
    { name : "LA - Lafayette" }, 
    { name : "LA - Lake Charles" }, 
    { name : "LA - Monroe" }, 
    { name : "LA - New Orleans" }, 
    { name : "LA - Shreveport-Bossier City" }, 
    { name : "MA - Barnstable-Yarmouth" }, 
     { name : "MA - Boston" }, 
    { name : "MA - Brockton" }, 
    { name : "MA - Fitchburg-Leominster" }, 
    { name : "MA - Lawrence-Haverhill, MA-NH" }, 
    { name : "MA - Lowell, MA-NH" }, 
    { name : "MA - New Bedford" }, 
    { name : "MA - Pittsfield" }, 
    { name : "MA - Providence-Fall River-Warwick, RI-MA" }, 
    { name : "MA - Springfield" }, 
    { name : "MA - Worcester" }, 
     { name : "MD - Baltimore" }, 
    { name : "MD - Cumberland, MD-WV" }, 
    { name : "MD - Hagerstown" }, 
    { name : "MD - Washington, DC-MD-VA" }, 
    { name : "MD - Wilmington, DE-NJ-MD" }, 
    { name : "ME - Bangor" }, 
    { name : "ME - Lewiston-Auburn" }, 
    { name : "ME - Portland" }, 
    { name : "ME - Portsmouth-Dover-Rochester, NH-ME" }, 
    { name : "MI - Ann Arbor" }, 
     { name : "MI - Benton Harbor" }, 
    { name : "MI - Detroit" }, 
    { name : "MI - Flint" }, 
    { name : "MI - Grand Rapids-Muskegon-Holland" }, 
    { name : "MI - Jackson" }, 
    { name : "MI - Kalamazoo-Battle Creek" }, 
    { name : "MI - Lansing-East Lansing" }, 
    { name : "MI - Saginaw-Bay City-Midland" }, 
    { name : "MN - Duluth-Superior, MN-WI" }, 
    { name : "MN - Fargo-Moorhead, ND-MN" }, 
     { name : "MN - Grand Forks, ND-MN" }, 
    { name : "MN - La Crosse, WI-MN" }, 
    { name : "MN - Minneapolis-St. Paul, MN-WI" }, 
    { name : "MN - Rochester" }, 
    { name : "MN - St. Cloud" }, 
    { name : "MO - Columbia" }, 
    { name : "MO - Joplin" }, 
    { name : "MO - Kansas City, MO-KS" }, 
    { name : "MO - Springfield" }, 
    { name : "MO - St. Joseph" }, 
     { name : "MO - St. Louis, MO-IL" }, 
    { name : "MS - Biloxi-Gulfport-Pascagoula" }, 
    { name : "MS - Hattiesburg" }, 
    { name : "MS - Jackson" }, 
    { name : "MS - Memphis,TN-AR-MS" }, 
    { name : "MT - Billings" }, 
    { name : "MT - Great Falls" }, 
    { name : "MT - Missoula" }, 
    { name : "NC - Asheville" }, 
    { name : "NC - Charlotte-Gastonia-Rock Hill, NC-SC" }, 
      { name : "NC - Fayetteville" }, 
     { name : "NC - Goldsboro" }, 
     { name : "NC - Greensboro--Winston-Salem--High Point" }, 
     { name : "NC - Greenville" }, 
     { name : "NC - Hickory-Morganton-Lenoir" }, 
     { name : "NC - Jacksonville" }, 
     { name : "NC - Norfolk-Virginia Beach-Newport News, VA-NC" }, 
     { name : "NC - Raleigh-Durham-Chapel Hill" }, 
     { name : "NC - Rocky Mount" }, 
     { name : "NC - Wilmington" }, 
     { name : "ND - Bismarck" }, 
    { name : "ND - Fargo-Moorhead, ND-MN" }, 
    { name : "ND - Grand Forks, ND-MN" }, 
    { name : "NE - Lincoln" }, 
    { name : "NE - Omaha, NE-IA" }, 
    { name : "NE - Sioux City, IA-NE" }, 
    { name : "NH - Boston, MA" }, 
    { name : "NH - Lawrence-Haverhill, MA-NH" }, 
    { name : "NH - Lowell, MA-NH" }, 
    { name : "NH - Manchester" }, 
     { name : "NH - Nashua" }, 
    { name : "NH - Portsmouth-Dover-Rochester, NH-ME" }, 
    { name : "NJ - AtlanticCity" }, 
    { name : "NJ - Bergen-Passaic" }, 
    { name : "NJ - Jersey City" }, 
    { name : "NJ - Middlesex-Somerset-Hunterdon" }, 
    { name : "NJ - Monmouth-Ocean" }, 
    { name : "NJ - Newark" }, 
    { name : "NJ - Philadelphia, PA-NJ" }, 
    { name : "NJ - Trenton" }, 
     { name : "NJ - Vineland-Millville-Bridgeton" }, 
    { name : "NM - Albuquerque" }, 
    { name : "NM - Las Cruces" }, 
    { name : "NM - Santa Fe" }, 
    { name : "NV - Las Vegas, NV-AZ" }, 
    { name : "NV - Reno" }, 
    { name : "NY - Albany-Schenectady-Troy" }, 
    { name : "NY - Binghamton" }, 
    { name : "NY - Buffalo-Niagara Falls" }, 
    { name : "NY - Dutchess County" }, 
     { name : "NY - Elmira" }, 
    { name : "NY - Glens Falls" }, 
    { name : "NY - Jamestown" }, 
    { name : "NY - Nassau-Suffolk" }, 
    { name : "NY - New York, NY-NJ" }, 
    { name : "NY - Newburgh-Middletown" }, 
    { name : "NY - Rochester" }, 
    { name : "NY - Syracuse" }, 
    { name : "NY - Utica-Rome" }, 
    { name : "OH - Akron" }, 
     { name : "OH - Canton-Massillon" }, 
    { name : "OH - Cincinnati, OH-KY-IN" }, 
    { name : "OH - Cleveland" }, 
    { name : "OH - Columbus" }, 
    { name : "OH - Dayton-Springfield" }, 
    { name : "OH - Hamilton-Middletown" }, 
    { name : "OH - Huntington-Ashland, WV-KY-OH" }, 
    { name : "OH - Lima" }, 
    { name : "OH - Mansfield" }, 
    { name : "OH - Parkersburg-Marietta, WV-OH" }, 
     { name : "OH - Steubenville-Weirton, OH-WV" }, 
    { name : "OH - Toledo" }, 
    { name : "OH - Wheeling, WV-OH" }, 
    { name : "OH - Youngstown-Warren" }, 
    { name : "OK - Enid" }, 
    { name : "OK - Fort Smith, AR-OK" }, 
    { name : "OK - Lawton" }, 
    { name : "OK - OklahomaCity" }, 
    { name : "OK - Tulsa" }, 
    { name : "OR - Corvallis" }, 
     { name : "OR - Eugene-Springfield" }, 
    { name : "OR - Medford-Ashland" }, 
    { name : "OR - Portland, OR-WA" }, 
    { name : "OR - Salem" }, 
    { name : "PA - Allentown-Bethlehem-Easton" }, 
    { name : "PA - Altoona" }, 
    { name : "PA - Erie" }, 
    { name : "PA - Harrisburg-Lebanon-Carlisle" }, 
    { name : "PA - Johnstown" }, 
    { name : "PA - Lancaster" }, 
     { name : "PA - Newburgh-Middletown, NY" }, 
    { name : "PA - Philadelphia, PA-NJ" }, 
    { name : "PA - Pittsburgh" }, 
    { name : "PA - Reading" }, 
    { name : "PA - Scranton--Wilkes-Barre--Hazleton" }, 
    { name : "PA - Sharon" }, 
    { name : "PA - State College" }, 
    { name : "PA - Washington, DC-MD-VA" }, 
    { name : "PA - Williamsport" }, 
    { name : "PA - York" }, 
     { name : "PR - Aguadilla" }, 
    { name : "PR - Arecibo" }, 
    { name : "PR - Caguas" }, 
    { name : "PR - Mayaguez" }, 
    { name : "PR - Ponce" }, 
    { name : "PR - San Juan" }, 
    { name : "RI - New London-Norwich, CT-RI" }, 
    { name : "RI - Providence-Fall River-Warwick, RI-MA" }, 
    { name : "SC - Augusta-Aiken, GA-SC" }, 
    { name : "SC - Charleston-North Charleston" }, 
      { name : "SC - Charlotte-Gastonia-Rock Hill, NC-SC" }, 
     { name : "SC - Columbia" }, 
     { name : "SC - Florence" }, 
     { name : "SC - Greenville-Spartanburg-Anderson" }, 
     { name : "SC - Myrtle Beach" }, 
     { name : "SC - Sumter" }, 
     { name : "SD - Rapid City" }, 
     { name : "SD - Sioux Falls" }, 
     { name : "TN - Chattanooga, TN-GA" }, 
     { name : "TN - Clarksville-Hopkinsville, TN-KY" }, 
     { name : "TN - Jackson" }, 
    { name : "TN - JohnsonCity-Kingsport-Bristol, TN-VA" }, 
    { name : "TN - Knoxville" }, 
    { name : "TN - Memphis,TN-AR-MS" }, 
    { name : "TN - Nashville" }, 
    { name : "TX - Abilene" }, 
    { name : "TX - Amarillo" }, 
    { name : "TX - Austin-San Marcos" }, 
    { name : "TX - Beaumont-Port Arthur" }, 
    { name : "TX - Brazoria" }, 
     { name : "TX - Brownsville-Harlingen-San Benito" }, 
    { name : "TX - Bryan-College Station" }, 
    { name : "TX - Corpus Christi" }, 
    { name : "TX - Dallas-Fort Worth" }, 
    { name : "TX - El Paso" }, 
    { name : "TX - Fort Worth" }, 
    { name : "TX - Galveston-Texas City" }, 
    { name : "TX - Houston" }, 
    { name : "TX - Killeen-Temple" }, 
    { name : "TX - Laredo" }, 
     { name : "TX - Longview-Marshall" }, 
    { name : "TX - Lubbock" }, 
    { name : "TX - McAllen-Edinburg-Mission" }, 
    { name : "TX - Odessa-Midland" }, 
    { name : "TX - San Angelo" }, 
    { name : "TX - San Antonio" }, 
    { name : "TX - Sherman-Denison" }, 
    { name : "TX - Texarkana, TX-Texarkana, AR" }, 
    { name : "TX - Tyler" }, 
    { name : "TX - Victoria" }, 
     { name : "TX - Waco" }, 
    { name : "TX - WichitaFalls" }, 
    { name : "UT - Flagstaff, AZ-UT" }, 
    { name : "UT - Provo-Orem" }, 
    { name : "UT - Salt Lake City-Ogden" }, 
    { name : "VA - Charlottesville" }, 
    { name : "VA - Danville" }, 
    { name : "VA - JohnsonCity-Kingsport-Bristol, TN-VA" }, 
    { name : "VA - Lynchburg" }, 
    { name : "VA - Norfolk-Virginia Beach-Newport News, VA-NC" }, 
     { name : "VA - Richmond-Petersburg" }, 
    { name : "VA - Roanoke" }, 
    { name : "VA - Washington, DC-MD-VA" }, 
    { name : "VT - Burlington" }, 
    { name : "WA - Bellingham" }, 
    { name : "WA - Bremerton" }, 
    { name : "WA - Olympia" }, 
    { name : "WA - Portland, OR-WA" }, 
    { name : "WA - Richland-Kennewick-Pasco" }, 
    { name : "WA - Seattle-Everett" }, 
     { name : "WA - Spokane" }, 
    { name : "WA - Tacoma" }, 
    { name : "WA - Yakima" }, 
    { name : "WI - Appleton-Oshkosh-Neenah" }, 
    { name : "WI - Duluth-Superior, MN-WI" }, 
    { name : "WI - Eau Claire" }, 
    { name : "WI - Green Bay" }, 
    { name : "WI - Janesville-Beloit" }, 
    { name : "WI - Kenosha" }, 
    { name : "WI - La Crosse, WI-MN" }, 
     { name : "WI - Madison" }, 
    { name : "WI - Milwaukee" }, 
    { name : "WI - Minneapolis-St. Paul, MN-WI" }, 
    { name : "WI - Racine" }, 
    { name : "WI - Sheboygan" }, 
    { name : "WI - Wausau" }, 
    { name : "WV - Charleston" }, 
    { name : "WV - Cumberland, MD-WV" }, 
    { name : "WV - Huntington-Ashland, WV-KY-OH" }, 
    { name : "WV - Parkersburg-Marietta, WV-OH" }, 
     { name : "WV - Steubenville-Weirton, OH-WV" }, 
    { name : "WV - Washington, DC-MD-VA" }, 
    { name : "WV - Wheeling, WV-OH" }, 
    { name : "WY - Casper" }, 
    { name : "WY - Cheyenne" }
    
];